export default __webpack_public_path__ + "static/media/PageNotFound2.39159d40.svg";